import type { Shortcut } from '../layout/header/shortcuts/type';
import { getCurrentUserEmail } from './tokenUtils';
import type { Service } from '../redux/types';

const STORAGE_KEY = 'shortcuts';

export const updateShortcut = (shortcut: Shortcut): void => {
  const existedShortcuts = localStorage.getItem(STORAGE_KEY) ?? '{}';
  const currentUser = getCurrentUserEmail() ?? 'default';

  try {
    const parsedShortcuts = JSON.parse(existedShortcuts);
    const userShortcuts = parsedShortcuts[currentUser] || [];

    const shortcutIndex = userShortcuts.findIndex((s: Shortcut) => s.id === shortcut.id);
    if (shortcutIndex !== -1) {
      userShortcuts.splice(shortcutIndex, 1);
    } else {
      userShortcuts.push(shortcut);
    }

    parsedShortcuts[currentUser] = userShortcuts;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(parsedShortcuts));
  } catch (e) {
    const newShortcuts = { [currentUser]: [{}] };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newShortcuts));
  }
};

export const getPinnedShortcuts = (): Shortcut[] => {
  const existedShortcuts = localStorage.getItem(STORAGE_KEY) ?? '{}';
  const currentUser = getCurrentUserEmail() ?? 'default';

  try {
    const parsedShortcuts = JSON.parse(existedShortcuts);
    return parsedShortcuts[currentUser] || [];
  } catch (e) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({}));
    return [];
  }
};

const getModuleTitleSet = (servicesList: Service[]): Record<string, string> => {
  return servicesList.reduce(
    (acc, service) => {
      acc[service.path] = service.title;
      return acc;
    },
    {} as Record<string, string>,
  );
};

export const remapShortcutsTemp = (servicesList: Service[]): void => {
  const currentUser = getCurrentUserEmail();
  if (!currentUser) {
    return;
  }

  const existedShortcuts = localStorage.getItem(STORAGE_KEY) ?? '{}';

  try {
    const parsedShortcuts = JSON.parse(existedShortcuts);
    const moduleTitleSet = getModuleTitleSet(servicesList);

    const userUpdatedShortcuts = parsedShortcuts[currentUser].map((sc: Shortcut) => {
      if (sc.moduleTitle) {
        return sc;
      }

      return {
        id: sc.id,
        moduleTitle: moduleTitleSet[sc.module] || sc.module,
        titles: sc.titles,
        path: sc.path,
        module: sc.module,
        iconContent: sc.iconContent,
        color: sc.color,
        permissions: sc.permissions,
      };
    });

    parsedShortcuts[currentUser] = userUpdatedShortcuts;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(parsedShortcuts));
  } catch (e) {
    const newShortcuts = { [currentUser]: [] };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newShortcuts));
  }
};
